module.exports = __webpack_public_path__ + "img/spengler_1_ocular.99a14b24.jpg";